import React from 'react';
import { Checkbox, Input } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';

import { FilterBar, FilterControlButton, SearchFilterPanelWrapper } from './styled';
import { ISearchFilterPanelProps } from './typed';
const SearchFilterPanel: React.FC<ISearchFilterPanelProps> = ({
  leftComp,
  searchValue,
  onSearch,
  filtersVisible,
  showFilters,
  onShowFilterChange,
  style,
}) => {
  const handleClearSearch = () => {
    onSearch?.('');
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value: inputValue } = e.target;
    onSearch?.(inputValue);
  };

  const handleToggleFilter = (e: CheckboxChangeEvent) => {
    const { checked } = e.target;
    onShowFilterChange?.(checked);
  };
  return (
    <SearchFilterPanelWrapper style={style}>
      {leftComp}
      <FilterBar>
        <Input
          prefix={<SearchOutlined />}
          suffix={<CloseOutlined onClick={handleClearSearch} />}
          onChange={handleSearch}
          placeholder="type something"
          size="small"
          autoFocus
          value={searchValue}
          style={{ width: 200 }}
        />
        {filtersVisible ? (
          <FilterControlButton>
            <Checkbox onChange={handleToggleFilter} checked={showFilters}>
              Show Filters
            </Checkbox>
          </FilterControlButton>
        ) : null}
      </FilterBar>
    </SearchFilterPanelWrapper>
  );
};

export default SearchFilterPanel;
